import { Component } from '@angular/core';
import { ClientSubscribeInfoComponent } from '@components/base/client/client-subscribe-info/client-subscribe-info';

@Component({
	selector: 'client-subscribe-info',
	template: require('./client-subscribe-info.html')
})
export class ClientSubscribeInfoWebComponent extends ClientSubscribeInfoComponent {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/client/client-subscribe-info/client-subscribe-info.ts